import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Totes_ShellService } from './Totes.shell.service';
import { Totes_OperationService } from './Totes.operation.service';
import { Totes_DatasourceService } from './Totes.datasource.index';
import { Totes_FlowService } from './Totes.flow.index';
import { Totes_FrontendFlowService } from './Totes.frontend.flow.service';
import { Totes_ReportService } from './Totes.report.index';
import { Totes_LocalizationService } from './Totes.localization.service';
import { Totes_tote_induction_form_ComponentContextService } from './Totes.tote_induction_form.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Totes.frontend.types'
import { $frontendTypes as $types} from './Totes.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Totes_warehouses_dd_singleComponent } from './Totes.warehouses_dd_single.component'

@Component({
  imports: [
    SharedModule,
    forwardRef(() => Totes_warehouses_dd_singleComponent),
  ],
  selector: 'Totes-tote_induction_form',
  templateUrl: './Totes.tote_induction_form.component.html'
})
export class Totes_tote_induction_formComponent extends BaseComponent implements OnInit, OnDestroy {


  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  formGroup: FormGroup = new FormGroup({
    warehouse: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    scan_tote_lookup: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  get valid(): boolean {
    return this.formGroup.valid;
  }
  
  toolbar = {
      back: new ToolModel(new ButtonModel('back', new ButtonStyles(null, null), false, false, false, 'Back', '', null)
    , false)
  };

  fields = {
    warehouse: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['warehouse'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Warehouse', false, false),
    scan_tote_lookup: new FieldModel(new TextBoxModel(this.formGroup.controls['scan_tote_lookup'] as DatexFormControl, null, false, false, '', null)
, new ControlContainerStyles(null, null), 'Tote lookup', false, false),
  };

  fieldsets = {
    newGroup1: new FieldsetModel(
      '',
      true,
      false,
      true,
      false,
        null
      ,
      () => {
        const $form = this;
        const $utils = this.$utils;
        return '';
      }
    ),
};

  //#region fields inParams
  //#endregion fields inParams

  $formGroupFieldValidationObservables = {
    warehouse: this.fields.warehouse.control.valueChanges
    ,
    scan_tote_lookup: this.fields.scan_tote_lookup.control.valueChanges
    ,
  }
  

  constructor(
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: Totes_ShellService,
private $datasources: Totes_DatasourceService,
private $flows: Totes_FlowService,
private $frontendFlows: Totes_FrontendFlowService,
private $reports: Totes_ReportService,
private $localization: Totes_LocalizationService,
private $operations: Totes_OperationService,
private $logger: CleanupLoggerService,
private $context: Totes_tote_induction_form_ComponentContextService,
) { 
    super();
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  initialized = false;

  async $init() {
    this.title = 'Tote induction';
  
    const $form = this;
    const $utils = this.$utils;

    


    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.$formGroupFieldValidationObservables
      .warehouse
      .pipe(takeUntil(this.$unsubscribe$))
      .subscribe();
    this.$formGroupFieldValidationObservables
      .scan_tote_lookup
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_tote_lookup_scanned();
      });
  }

  close() {
    this.$finish.emit();
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
 
  //#region private flows
  on_back_button_clicked(event = null) {
    return this.on_back_button_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_back_button_clickedInternal(
    $form: Totes_tote_induction_formComponent,
  
    $shell: Totes_ShellService,
    $datasources: Totes_DatasourceService,
    $flows: Totes_FlowService,
    $frontendFlows: Totes_FrontendFlowService,
    $reports: Totes_ReportService,
    $settings: SettingsValuesService,
    $operations: Totes_OperationService,
    $utils: UtilsService,
    $context: Totes_tote_induction_form_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Totes_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Totes', 'tote_induction_form.on_back_button_clicked');
  $shell.Totes.opentotes_home(true)
  }
  on_tote_lookup_scanned(event = null) {
    return this.on_tote_lookup_scannedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_tote_lookup_scannedInternal(
    $form: Totes_tote_induction_formComponent,
  
    $shell: Totes_ShellService,
    $datasources: Totes_DatasourceService,
    $flows: Totes_FlowService,
    $frontendFlows: Totes_FrontendFlowService,
    $reports: Totes_ReportService,
    $settings: SettingsValuesService,
    $operations: Totes_OperationService,
    $utils: UtilsService,
    $context: Totes_tote_induction_form_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Totes_LocalizationService,
    $event: any
  ) {
    this.$logger.log('Totes', 'tote_induction_form.on_tote_lookup_scanned');
  
  if ($utils.isDefined($form.fields.warehouse.control.value)) {
      let inductTote = (await $flows.Totes.induct_tote({ tote_lookup_code: $form.fields.scan_tote_lookup.control.value, warehouseId: $form.fields.warehouse.control.value }))
      if ($utils.isDefined(inductTote.reasons)) {
          $shell.Totes.openErrorDialog('Error inducting tote', inductTote.reasons.join(', '))
      } else {
          $shell.Totes.openToaster('Tote inducted', `Tote ${$form.fields.scan_tote_lookup.control.value} has been successfully inducted into PLC`, EToasterType.Success)
  
      }
  } else {
      $shell.Totes.openErrorDialog('No warehouse selected', 'Please select warehouse before continuing')
  }
  $form.fields.scan_tote_lookup.control.value = null
  $form.fields.scan_tote_lookup.control.focus();
  }
  //#endregion private flows
}
